import {NavLink} from 'react-router-dom';
import {Box, Breadcrumbs} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {Product} from '../types';
import config from '../config';

export const DetailPageNavigation = ({component}: { component: Product }) => {

    const breadcrumbs = [{
        title: I18n.get('Home'),
        href: '/dashboard',
    }, {
        title: I18n.get(config.titles.plural),
        href: config.basePath,
    }, {
        title: component.name,
        href: '',
    }].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p='xs'><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
